import AppScreen from "./app-screen";

export default AppScreen;